var animations = {

    init: function() {
        this.openSlide();
        this.carouselInit();
    },

    _isScrolledIntoView: function(el) {
        var elemTop = el[0].getBoundingClientRect().top;
        var elemBottom = el[0].getBoundingClientRect().bottom;

        var isVisible =
        elemTop >= -480 && elemTop <= 300 && elemBottom <= $(document).height();
        return isVisible;
    },

    playAnimations: function() {
        var $markersContainer = $(".ip-markers");
        $markersContainer.addClass("playAnimations");
    },

    openSlide: function() {
        var $marker = $(".ip-marker");
        var $carousel = $('.ip-carousel-container');

        $marker.on("click", function() {
            var num = $(this).index();
            $marker.removeClass("active");
            $(this).addClass("active");

            $carousel.slick('slickGoTo', num);

            window.parent.$('html, body').animate({
                scrollTop: $carousel.offset().top
            }, 500);
        });
    },

    carouselInit: function() {
        var $carousel = $('.ip-carousel-container'),
            $marker = $(".ip-marker"),
            $currSlide = $(".curr-slide");

        $carousel.slick({
            dots: true,
            prevArrow: $(".prev-arrow"),
            nextArrow: $(".next-arrow"),
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });

        $carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $currSlide.html(nextSlide + 1);
            $marker.removeClass("active");
            $marker.eq(nextSlide).addClass("active");
        });
    }

}